import { useIsQaScanActive } from "@components/QaReview/hooks/useIsQaScanActive";
import { useSidebarView } from "@providers/SidebarViewProvider/useSidebarView";

export const useIsReviewPanelVisible = (): boolean => {
  const isQaScanActive = useIsQaScanActive();
  const { view } = useSidebarView();

  return isQaScanActive && view === "review";
};
